export interface Role {
  key: string
  title: string
  description: string
}

export const roles: Role[] = [
  {
    key: 'management',
    title: 'who.roles.management.title',
    description: 'who.roles.management.description'
  },
  {
    key: 'listing-managers',
    title: 'who.roles.listingManagers.title',
    description: 'who.roles.listingManagers.description'
  },
  {
    key: 'inventory-fulfillment',
    title: 'who.roles.inventoryFulfillment.title',
    description: 'who.roles.inventoryFulfillment.description'
  },
  {
    key: 'operations-support',
    title: 'who.roles.operationsSupport.title',
    description: 'who.roles.operationsSupport.description'
  }
]